import React, { Component } from 'react';
import FormInputText from '../../_shared/forms/FormInputText';
import ReactDOM from 'react-dom';

class TeamMemberForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            first_name: '',
            last_name: '',
            email: '',
            mobile: '',
            image: '',
            errors: {},
        };
    }

    render() {
        const { first_name, last_name, email, mobile, image, errors } = this.state;

        return (
            <form>
                <div className="row">
                    <div className="col-12">
                        <h6 className="py-2 pl-2 bg-secondary text-white">Add Team Member</h6>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <FormInputText
                            label="First Name"
                            name="first_name"
                            type="text"
                            classes={errors.first_name ? 'form-control is-invalid' : 'form-control'}
                            value={first_name}
                            handleChange={this.handleInputChange}
                            error={errors.first_name}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="Bank Account Number"
                            name="bank_account_number"
                            type="text"
                            classes={errors.last_name ? 'form-control is-invalid' : 'form-control'}
                            value={last_name}
                            handleChange={this.handleInputChange}
                            error={errors.last_name}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="Email"
                            name="email"
                            type="email"
                            classes={errors.email ? 'form-control is-invalid' : 'form-control'}
                            value={email}
                            handleChange={this.handleInputChange}
                            error={errors.email}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <FormInputText
                            label="Mobile"
                            name="mobile"
                            type="text"
                            classes={errors.mobile ? 'form-control is-invalid' : 'form-control'}
                            value={mobile}
                            handleChange={this.handleInputChange}
                            error={errors.mobile}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="Image"
                            name="image"
                            type="file"
                            classes={errors.image ? 'form-control is-invalid' : 'form-control'}
                            value={image}
                            handleChange={this.handleInputChange}
                            error={errors.image}
                        />
                    </div>
                    <div className="col-md-4">
                        <FormInputText
                            label="Email"
                            name="email"
                            type="email"
                            classes={errors.email ? 'form-control is-invalid' : 'form-control'}
                            value={email}
                            handleChange={this.handleInputChange}
                            error={errors.email}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <button className="btn btn-primary btn-block">
                            <i className="fas fa-plus-square"> </i> Add new team member
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

export default TeamMemberForm;
